export default class RuneStatus {
  value = "";
  same = false;
  rise = "";
  use = false;
}